<template>
    <div class="v2-tab-content">
        <div class="page-section">
            <a-card :bordered="false" style="width: 100%">
                <template slot="title">
                    <div class="v2-tab-hd">
                        <h2>Condições de entrega</h2>
                    </div>
                </template>
                <template v-if="editable" slot="extra">
                    <a-button type="primary" :loading="saving" :disabled="!changed" @click="save">
                        <i v-if="!saving" class="fa-solid fa-floppy-disk"></i>
                        Salvar condições
                    </a-button>
                </template>

                <a-alert v-if="editable && !complete" type="warning" show-icon class="delivery-alert" message="Informe o prazo de entrega e o tipo de pagamento para aprovar a requisição." />

                <DeliveryFields :form="form" :editable="editable" />
            </a-card>
        </div>
    </div>
</template>

<script>
import DeliveryFields from "../components/delivery-fields.vue";
import { formOf, payloadOf, deliveryComplete } from "../delivery";

export default {
    name: "SellerOrderDeliveryTab",
    components: { DeliveryFields },
    props: {
        order: { type: Object, required: true },
        editable: { type: Boolean, default: false },
        saving: { type: Boolean, default: false },
    },
    data() {
        return {
            form: formOf(this.order.delivery),
        };
    },
    computed: {
        changed() {
            return JSON.stringify(payloadOf(this.form)) !== JSON.stringify(payloadOf(formOf(this.order.delivery)));
        },
        complete() {
            return deliveryComplete(this.order.delivery);
        },
    },
    watch: {
        "order.delivery"(delivery) {
            this.form = formOf(delivery);
        },
    },
    methods: {
        save() {
            this.$emit("save", payloadOf(this.form));
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/pages/visits/_detail-page";

.delivery-alert {
    margin-bottom: 16px;
}
</style>
